import VacationConfirmAwaitingWidget from "./VacationConfirmAwaitingWidget.vue";
import VacationApprovedWidget from "./VacationApprovedWidget.vue";
import VacationRejectedWidget from "./VacationRejectedWidget.vue";

export { VacationConfirmAwaitingWidget, VacationApprovedWidget, VacationRejectedWidget };
